<template>
  <div>
    <Header></Header>
    <div class="col-12 d-inline-flex">
      <div class="col-10 no-overflow ms-3 me-3 pt-3" style="position: relative;">
        <div class="stripe-configuration">
          <h2>{{ editMode ? 'Edit' : 'Create' }} Video Quality</h2>
          <form @submit.prevent="saveChanges">
            <div v-for="field in fields" :key="field.name" class="form-group">
              <label :for="field.name">{{ field.label }}:</label>
              <input v-if="(field.name !== 'active' && field.name !== 'application') || (field.name === 'videoQualityKey' && editMode)"
                     :id="field.name" v-model="editedConfig[field.name]" :style="{ minWidth: '500px', width: editedConfig[field.name] ? `${editedConfig[field.name].length * 10}px` : '100px' }"
                     type="text" class="form-control" :disabled="(field.name === 'videoQualityKey') && editMode">
              <select v-else-if="field.name === 'application'" :id="field.name" v-model="editedConfig[field.name]" class="form-select" style="max-width: 500px;">
                <option v-for="app in applicationList" :key="app" :value="app">{{ app }}</option>
              </select>
              <input class="checkbox" v-else-if="field.name === 'active'"
                     type="checkbox" :id="field.name" v-model="editedConfig[field.name]">
            </div>

            <div v-if="error != ''" class="error-message">{{error}}</div>
            <br>
            <a role="button" class="procricket-btn" @click="saveChanges">{{ editMode ? 'Save Changes' : 'Create Video Quality' }}</a>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import {VideoQuality} from '@/model/models'
import AdminService from "@/services/admin-service";

export default defineComponent({
  name: 'VideoQualityEdit',
  components: {
    Header,
  },
  data () {
    return {
      editedConfig: {
        videoQualityKey : this.$route.params.videoQualityKey,
        videoQualityValue : this.$route.params.videoQualityValue,
        active: this.$route.params.active,
        application: this.$route.params.application,
      },
      editMode: false,
      applicationList: [],
      fields: [
        { name: "videoQualityKey", label: "Video quality Key" },
        { name: "videoQualityValue", label: "Video quality Value" },
        { name: "active", label: "Active" },
        { name: "application", label: "Application" }
      ],
      error: ""
    }
  },
  created() {
    if (this.$route.params.videoQualityKey) {
      this.editMode = true;
    }
    const storedApps = localStorage.getItem('applicationList');
    if (storedApps) {
      this.applicationList = JSON.parse(storedApps);
    } else {
      AdminService.getApplications().then(() => {
        this.applicationList = JSON.parse(localStorage.getItem('applicationList'));
      });
    }
  },
  methods: {
    saveChanges() {
      const dataToSave = new VideoQuality(
          this.editedConfig.videoQualityKey,
          this.editedConfig.videoQualityValue,
          this.editedConfig.active,
          this.editedConfig.application
      );
      if (this.editMode) {
        // Editing an existing configuration
        AdminService.updateVideoQuality(dataToSave).then(() => {
          alert('Update complete');
          // Redirect to the page
          this.$router.push({ name: 'VideoQualities' });
        }).catch((error) => {
          if (error.response && error.response.data && error.response.data.message) {
            alert(error.response.data.message);
          }
        });
      } else {
        AdminService.insertVideoQuality(dataToSave).then(() => {
          alert('Insert complete');
          // Redirect to the page
          this.$router.push({ name: 'VideoQualities' });
        }).catch((error) => {
          this.error = error.message
        });
      }
    }

  }
})
</script>
<style src="../../assets/style.css">
</style>
